import { render, staticRenderFns } from "./UserHelpCategory.vue?vue&type=template&id=4b24392b&scoped=true&"
import script from "./UserHelpCategory.vue?vue&type=script&lang=ts&"
export * from "./UserHelpCategory.vue?vue&type=script&lang=ts&"
import style0 from "./UserHelpCategory.vue?vue&type=style&index=0&id=4b24392b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b24392b",
  null
  
)

export default component.exports